import React from "react";
import { Flex } from "@chakra-ui/react";
import { PageHeader } from "components";
import { FluidBolus, DefibMedications, Medications } from "../shared";

const EmergencyDrugs: React.FC = () => (
  <>
    <PageHeader title="CPR Emergency Drugs and Doses" backURL={-1} />

    <Flex mt="8" direction="column" rowGap={12}>
      <Medications />
      <DefibMedications />
      <FluidBolus />
    </Flex>
  </>
);

export default EmergencyDrugs;
